<template>
    <div class="comparison__cont" v-if="!loading && productsList">
        <div class="comparison-tabs__list">
            <div class="comparison-tabs__list-item active">
                <div class="compare-slider-wrap">
                    <CompareList v-if="productsList"/>
                    <div class="compare-slider__cont compare-slider__cont--left" v-if="productsList">
                        <template v-if="!isTablet">
                            <Images ref="Images" @next-slide="$refs.Desc.nextSlide()" @prev-slide="$refs.Desc.prevSlide()"/>
                            <Desc ref="Desc"/>
                        </template>
                        <template v-else>
                            <ImgSlider ref="imgSlider_1"/>
                            <DescSlider ref="descSlider_1"/>
                        </template>
                    </div>
                    <div v-if="isTablet && productsList" class="compare-slider__cont compare-slider__cont--right">
                        <ImgSlider ref="imgSlider_2"/>
                        <DescSlider ref="descSlider_2"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImgSlider from "../components/compareApp/ImgSlider";
import DescSlider from "../components/compareApp/DescSlider";
import CompareList from "../components/compareApp/CompareList";
import {mapState, mapActions, mapMutations} from "vuex";
import Images from "../components/compareApp/Images";
import Desc from "../components/compareApp/Desc";
import oneHeightElements from "../utils/one-height";

export default {
    name: 'compareSection',
    props: {
        currentProd: {
            type: Object,
            default: null,
        }
    },
    components: {
        Desc,
        Images,
        CompareList,
        DescSlider,
        ImgSlider,
    },
    data() {
        return {
            windowWidth: 0,
            isTablet: false,
            loading: false,
        }
    },
    async created() {
        this.loading = true
        await this.loadProducts()
        this.loading = false
    },
    async mounted() {
        oneHeightElements('.compare-card__top')
        oneHeightElements('.compare-card__design')
        oneHeightElements('.compare-card__list-title')
        oneHeightElements('.compare-card__item-label')
        oneHeightElements('.compare-card__item-text')
        oneHeightElements('.compare-card__item-info')
        oneHeightElements('.compare-card__list .product-docs')
        await this.setWindowWidth()
        window.addEventListener('resize', this.setWindowWidth)
        window.addEventListener('resize', () => {
            oneHeightElements('.compare-card__top')
            oneHeightElements('.compare-card__design')
            oneHeightElements('.compare-card__list-title')
            oneHeightElements('.compare-card__item-label')
            oneHeightElements('.compare-card__item-text')
            oneHeightElements('.compare-card__item-info')
            oneHeightElements('.compare-card__list .product-docs')
        })
    },
    updated() {
        oneHeightElements('.compare-card__top')
        oneHeightElements('.compare-card__design')
        oneHeightElements('.compare-card__list-title')
        oneHeightElements('.compare-card__item-label')
        oneHeightElements('.compare-card__item-text')
        oneHeightElements('.compare-card__item-info')
        oneHeightElements('.compare-card__list .product-docs')
    },
    computed: {
        ...mapState({
            'productsList': state => state.productsList,
        })
    },
    methods: {
        setWindowWidth() {
            this.windowWidth = window.innerWidth
            this.isTablet = this.windowWidth <= 1024;
            if (this.isTablet) {
                setTimeout(() => this.setController(), 500)
            }
        },
        setController() {
            let imgSwiper
            let descSwiper
            for (let i = 1; i <= 2; i++) {
                imgSwiper = this.$refs[`imgSlider_${i}`].imgSlider
                descSwiper = this.$refs[`descSlider_${i}`].descSlider

                imgSwiper.controller.control = descSwiper
                descSwiper.controller.control = imgSwiper
            }
        },
        ...mapActions({
            loadProducts: 'loadProducts',
        }),
    }
}
</script>

<style lang="css">

</style>
